import React from 'react';
import { TTicketPriority } from 'models/SupportTicket';
import { TICKET_PRIORITY_BADGE_COLOR } from '../../utilTicket';

// Badge nền màu theo mức ưu tiên — dùng trong Select độ ưu tiên (tạo phiếu, ô nhập xử lý)
export const PriorityBadge = ({ p, children }: { p: TTicketPriority; children: React.ReactNode }) => (
  <span
    style={{
      background: TICKET_PRIORITY_BADGE_COLOR[p],
      color: 'white',
      padding: '2px 8px',
      borderRadius: 2
    }}
  >
    {children}
  </span>
);
